// extracted by mini-css-extract-plugin
export default {"select":"Select_select__US+1l","select__wrapper":"Select_select__wrapper__IRdZL"};